export default () => {
  return process.env.REACT_APP_RECURLY_MODE !== 'production';
};
